/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface DashboardSpiderModel
 */
export interface DashboardSpiderModel {
  /**
   *
   * @type {number}
   * @memberof DashboardSpiderModel
   */
  id: number;
  /**
   *
   * @type {string}
   * @memberof DashboardSpiderModel
   */
  aiModel: string;
  /**
   *
   * @type {number}
   * @memberof DashboardSpiderModel
   */
  performanceValue: number;
  /**
   *
   * @type {number}
   * @memberof DashboardSpiderModel
   */
  robustnessValue: number;
  /**
   *
   * @type {number}
   * @memberof DashboardSpiderModel
   */
  explainabilityValue: number;
  /**
   *
   * @type {number}
   * @memberof DashboardSpiderModel
   */
  fairnessValue: number;
  /**
   *
   * @type {number}
   * @memberof DashboardSpiderModel
   */
  totalValue: number;
}

/**
 * Check if a given object implements the DashboardSpiderModel interface.
 */
export function instanceOfDashboardSpiderModel(value: object): value is DashboardSpiderModel {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('aiModel' in value) || value['aiModel'] === undefined) return false;
  if (!('performanceValue' in value) || value['performanceValue'] === undefined) return false;
  if (!('robustnessValue' in value) || value['robustnessValue'] === undefined) return false;
  if (!('explainabilityValue' in value) || value['explainabilityValue'] === undefined) return false;
  if (!('fairnessValue' in value) || value['fairnessValue'] === undefined) return false;
  if (!('totalValue' in value) || value['totalValue'] === undefined) return false;
  return true;
}

export function DashboardSpiderModelFromJSON(json: any): DashboardSpiderModel {
  return DashboardSpiderModelFromJSONTyped(json, false);
}

export function DashboardSpiderModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): DashboardSpiderModel {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    aiModel: json['ai_model'],
    performanceValue: json['performance_value'],
    robustnessValue: json['robustness_value'],
    explainabilityValue: json['explainability_value'],
    fairnessValue: json['fairness_value'],
    totalValue: json['total_value'],
  };
}

export function DashboardSpiderModelToJSON(value?: DashboardSpiderModel | null): any {
  if (value == null) {
    return value;
  }
  return {
    id: value['id'],
    ai_model: value['aiModel'],
    performance_value: value['performanceValue'],
    robustness_value: value['robustnessValue'],
    explainability_value: value['explainabilityValue'],
    fairness_value: value['fairnessValue'],
    total_value: value['totalValue'],
  };
}
